// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".viewport {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  background: #242424;\n}\n.embed-camera {\n  height: 100%;\n  width: 100%;\n  position: relative;\n}\n.embed-camera > iframe {\n  position: absolute !important;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100% !important;\n  height: 100% !important;\n}", ""]);
// Exports
module.exports = exports;
